import { combineReducers } from "redux";
import startupReducer from "./startupReducer";
import libraryCardReducer from "./libraryCardReducer";
import docsReducer from "./docsReducer";

const rootReducer = combineReducers({
  startup: startupReducer,
  libraryCards: libraryCardReducer,
  docs: docsReducer,
});

export default rootReducer;
